import React from 'react'
import styles from './suspense.styles'
import injectSheet from 'react-jss'
import Spinner from 'pobble-components/dist/spinner'

const Suspense = ({ classes, children, pending }) =>
  pending ? (
    <div className={classes.container}>
      <Spinner />
    </div>
  ) : (
    children
  )

export default injectSheet(styles)(Suspense)
